import { render, staticRenderFns } from "./AlphaSlider.vue?vue&type=template&id=71bb4f0a&scoped=true"
import script from "./AlphaSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlphaSlider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlphaSlider.vue?vue&type=style&index=0&id=71bb4f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb4f0a",
  null
  
)

export default component.exports